// extracted by mini-css-extract-plugin
export default {"tooltip":"An-z","sharingV2":"Bn-z","sharingIconsV2":"Cn-z","links":"Dn-z","link":"En-z","facebookV2":"Fn-z","twitterV2":"Gn-z","pinterestV2":"Hn-z"};